// extracted by mini-css-extract-plugin
export var cActive = "styles-module--c-active--ff4b4";
export var cDropdown = "styles-module--c-dropdown--ef724";
export var cLangRow = "styles-module--c-lang-row--0d1ab";
export var cLink = "styles-module--c-link--61d78";
export var cList = "styles-module--c-list--5db3e";
export var cListElement = "styles-module--c-listElement--90134";